module.exports = __webpack_public_path__ + "media/morning_radio.d43ec497.ogg";